export default __webpack_public_path__ + "static/media/user.f3b9a809.svg";